/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteNetworkIngressSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type DeleteNetworkIngressRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type DeleteNetworkIngressSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const DeleteNetworkIngressSecurity$outboundSchema: z.ZodMiniType<
  DeleteNetworkIngressSecurity$Outbound,
  DeleteNetworkIngressSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function deleteNetworkIngressSecurityToJSON(
  deleteNetworkIngressSecurity: DeleteNetworkIngressSecurity,
): string {
  return JSON.stringify(
    DeleteNetworkIngressSecurity$outboundSchema.parse(
      deleteNetworkIngressSecurity,
    ),
  );
}

/** @internal */
export type DeleteNetworkIngressRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const DeleteNetworkIngressRequest$outboundSchema: z.ZodMiniType<
  DeleteNetworkIngressRequest$Outbound,
  DeleteNetworkIngressRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function deleteNetworkIngressRequestToJSON(
  deleteNetworkIngressRequest: DeleteNetworkIngressRequest,
): string {
  return JSON.stringify(
    DeleteNetworkIngressRequest$outboundSchema.parse(
      deleteNetworkIngressRequest,
    ),
  );
}
